import {FileConfiguration} from '../../file/message/FileConfiguration';

export class WriteFile {
exitStatusOnWrittenFile: boolean | null;
file: FileConfiguration;
keepFile: boolean | null;
}

